'use strict';

(function (angular) {
  angular.module('zp').controller('ShopItemController', shopItemController);

  /**@ngInject */
  function shopItemController($state, $timeout, ShopService, LoaderService) {
    var vm = this;

    vm.item = null;
    vm.items = [];

    vm.openItem = openItem;

    /**Activate */
    (function () {
      LoaderService.start();
      loadItem().then(loadItems).then(function () {
        $timeout(LoaderService.stop, 1000);
      });
    })();

    function loadItem() {
      return ShopService.getOne($state.params.name).then(function (response) {
        if (!response) {
          $state.go('nav.shop');
        }
        vm.item = response;
      });
    }

    function loadItems() {
      return ShopService.getAll().then(function (response) {
        for (var i = 0; i < response.length; i++) {
          if (response[i].name !== vm.item.name) {
            vm.items.push(response[i]);
          }
        }
      });
    }

    function openItem(item) {
      $state.go('nav.shop-item', { name: item.name });
    }
  }
})(window.angular);